import { Organization } from '@omniafishing/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getOrganizations } from '../../redux/organizations';
import { RoutePaths } from '../../routes';
import styles from './orgs_list.less';
import { DockableVideoPlayer } from '../video_player/dockable_video_player';

const ORG_PAGE_VIDEO_MUX_ID = 'ZWT1Xf2K02WzMFyrtev02THsEle8nwyWhvsHXvKs8dH6M';

export const OrgsList = () => {
  const organizations = useSelector(getOrganizations);
  const az = '#abcdefghijklmnopqrstuvwxyz'.split('');
  const azHash = az.reduce((acc, letter) => {
    acc[letter] = [];
    return acc;
  }, {} as Record<string, Organization[]>);

  const unRestrictedOrgs = organizations.filter((org) => org.restrict_membership === false);
  unRestrictedOrgs.forEach((org) => {
    let letter = org.name[0].toLowerCase();
    if (letter === Number(letter).toString()) {
      letter = '#';
    }
    azHash[letter].push(org);
  });

  return (
    <section>
      <h1 className={styles.heading}>Organizations</h1>
      <div className={styles.videoContainer}>
        <DockableVideoPlayer muxPlaybackId={ORG_PAGE_VIDEO_MUX_ID} thumbnailTimeStamp={49} />
      </div>
      <ul className={styles.organizations}>
        {Object.keys(azHash).map((letter) => {
          const letterOrgs = azHash[letter];
          if (letterOrgs.length) {
            return (
              <li key={letter}>
                <span className={styles.letter}>{letter}</span>

                <ul className={styles.letterOrgs}>
                  {letterOrgs.map((org, i) => {
                    const letterId = i === 0 ? letter : null;
                    return (
                      <li className={styles.organizationsItem} key={org.slug} id={letterId}>
                        <Link
                          to={`${RoutePaths.ORGS}/${org.slug}`}
                          className={styles.organizationsLink}
                        >
                          {org.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          }
        })}
      </ul>
    </section>
  );
};
